module.exports = __webpack_public_path__ + "static/media/dog-404.e36f99a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dog-404.svg
// module id = 917
// module chunks = 0